/* CS Zo werkt het: klikbare stappen wisselen het beeld (alleen de
   interactieve PDP-layout laadt dit script). Mobiel is de sectie statisch
   (CSS toont altijd het eerste beeld); kliks worden daar genegeerd zodat
   aria-pressed niet toggelt zonder zichtbaar effect. */
(() => {
  /* De theme editor voert sectiescripts opnieuw uit bij elke re-render;
     zonder guard stapelen de document-listeners zich op. */
  if (window.__csZwhInit) return;
  window.__csZwhInit = true;

  const initZwh = (section) => {
    const root = section.querySelector('[data-cs-zwh]');
    if (!root || root.dataset.csInit === '1') return;
    root.dataset.csInit = '1';

    const stappen = Array.from(root.querySelectorAll('[data-cs-zwh-stap]'));
    const fotos = Array.from(root.querySelectorAll('[data-cs-zwh-foto]'));
    const captionEl = root.querySelector('[data-cs-zwh-caption]');
    const captionTekst = root.querySelector('[data-cs-zwh-caption-tekst]');
    if (!stappen.length) return;

    const kiesStap = (index) => {
      stappen.forEach((stap, i) => {
        stap.classList.toggle('is-actief', i === index);
        stap.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      fotos.forEach((foto, i) => foto.classList.toggle('is-actief', i === index));
      /* Het tijdstip hoort bij de foto die net gewisseld is. Zonder caption
         valt de balk weg in plaats van leeg te blijven staan. */
      if (captionEl && captionTekst) {
        const tekst = stappen[index] ? stappen[index].dataset.caption || '' : '';
        captionTekst.textContent = tekst;
        captionEl.hidden = tekst === '';
      }
    };

    root.csKiesStap = kiesStap;

    stappen.forEach((stap, i) => {
      stap.addEventListener('click', () => kiesStap(i));
    });
  };

  document.querySelectorAll('.section-cs-zwh').forEach(initZwh);

  /* Theme editor rendert secties opnieuw zonder page load. */
  document.addEventListener('shopify:section:load', (event) => initZwh(event.target));

  /* Blok geselecteerd in de zijbalk = bijbehorende stap tonen, anders is de
     wijziging voor de merchant onzichtbaar. */
  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof Element)) return;
    const stap = event.target.closest('[data-cs-zwh-stap]');
    const root = event.target.closest('[data-cs-zwh]');
    if (!stap || !root || !root.csKiesStap) return;
    const stappen = Array.from(root.querySelectorAll('[data-cs-zwh-stap]'));
    root.csKiesStap(stappen.indexOf(stap));
  });
})();
